import { useFormik } from 'formik';
import { useEffect } from 'react';
import CustomAlert from '../../../../components/Shared/Alert/CustomAlert';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { getUserById, getUsers, UpdateAuthUser } from '../../../../store/NTX/Security/usersSlice';
import { formAddUserSchema } from '../../../ValidationForm/validationSchema';

import Select from 'react-select';
import { ntxAPI } from '../../../../API/axiosNeatex.js';
import showConfirmation from '../../../../components/Shared/Alert/Confirmation';
import Loading from '../../../../components/Shared/Loader/Loading';
import useLookupPeopleCode from '../../../../hooks/Lookups/use-Get_PEOPLE_CODE';
import Reference from './Reference';

function EditUser({ userId }) {
  const { t, i18n } = useTranslation();

  const dispatch = useDispatch();
  const { OptionsPeopleCode, loading, error } = useLookupPeopleCode();
  const UserTypes = [{ label: t('employee'), value: 'EMPLOYEE' }, ...OptionsPeopleCode];

  //
  const { User, loading2 } = useSelector((state) => state.Users);
  useEffect(() => {
    dispatch(getUserById(userId));
  }, [dispatch, userId]);

  ///
  const formik = useFormik({
    initialValues: {
      usersName: User ? User.usersName : '',
      usersPass: User ? User.usersPass : '',
      emailAddress: User ? User.emailAddress : '',
      usersMobile: User ? User.usersMobile : '',
      description: User ? User.description : '',
      userType: User ? User.userType : '',
      referenceId: User ? User.referenceId : '',
      isActive: User ? User.isActive : false,
      startDate: User ? User.startDate : '',
      endDate: User ? User.endDate : '',
      usersImage: User ? User.usersImage : '',
    },

    validationSchema: formAddUserSchema(t),
    enableReinitialize: true,
    onSubmit: (values) => {
      dispatch(
        UpdateAuthUser({
          id: userId,
          userType: values.userType,
          referanceId: values.referenceId,
          usersName: values.usersName,
          usersImage: values.usersImage,
          emailAddress: values.emailAddress,
          usersMobile: values.usersMobile,
          startDate: values.startDate,
          description: values.description,
          isActive: values.isActive,

          //
          // lastLogonDate: null,
          // flgPass: null,
          // refreshTokenExpairyDate: null,
          // refreshToken: null,
        })
      )
        .unwrap()
        .then(() => {
          CustomAlert({ action: 'Add' });
          dispatch(getUsers());
          // Navigate(-1, { replace: true });
        })
        .catch((error) => {
          CustomAlert({ action: 'Error' });
        })
        .finally(() => formik.setSubmitting(false));
    },
  });

  const handleResetPassword = () => {
    showConfirmation('هل أنت متأكد من إعادة تعيين كلمة المرور', async () => {
      const { data } = await ntxAPI.post('Security/ResetPassword', {
        userId: userId,
      });

      if (data?.succeeded === true) {
        CustomAlert({ action: 'Add', msg: 'تمت إعادة التعيين بنجاح' });
      } else {
        CustomAlert({ action: 'Error' });
      }
    });
  };

  //_______________

  return (
    <>
      <Loading loading={loading2 || loading} error={error} Type="Dots">
        <Form onSubmit={formik.handleSubmit}>
          <div className="row">

            <div className="col-xl-6">
              <div className="form-group mb-3">
                <label className="form-label">{t('TypeOfUser')}</label>
                <Select
                  classNamePrefix="react-select"
                  isLoading={loading}
                  isSearchable={true}
                  name="userType"
                  options={UserTypes}
                  onChange={(option) => {
                    formik.setFieldValue('userType', option === null ? '' : option.value);
                  }}
                  value={UserTypes.find((f) => f.value === formik.values.userType)}
                  placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                />
              </div>
            </div>

            <div className="col-xl-6">
              <div className="form-group mb-3">
                <Reference formik={formik} />
                {formik.errors.referenceId && formik.touched.referenceId && (
                  <div style={{ color: 'red' }}>{formik.errors.referenceId}</div>
                )}
              </div>
            </div>

            <div className="col-xl-4">
              <div className="form-group mb-3">
                <label className="form-label">{t('UserName')}</label>
                <Form.Control
                  className="form-control"
                  type="text"
                  autoComplete="off"
                  name="usersName"
                  onChange={formik.handleChange}
                  value={formik.values.usersName || ''}
                  isInvalid={formik.touched.usersName && formik.errors.usersName}
                />
                <Form.Control.Feedback type="invalid">
                  {formik.errors.usersName}
                </Form.Control.Feedback>
              </div>
            </div>

            <div className="col-xl-4">
              <div className="form-group mb-3">
                <label className="form-label">{t('Email')}</label>
                <Form.Control
                  className="form-control"
                  type="text"
                  autoComplete="off"
                  name="emailAddress"
                  onChange={formik.handleChange}
                  value={formik.values.emailAddress || ''}
                  isInvalid={formik.touched.emailAddress && formik.errors.emailAddress}
                />
              </div>
            </div>

            <div className="col-xl-4">
              <div className="form-group mb-3">
                <label className="form-label">{t('MobileNumber')}</label>
                <Form.Control
                  className="form-control"
                  type="text"
                  autoComplete="off"
                  name="usersMobile"
                  onChange={formik.handleChange}
                  value={formik.values.usersMobile || ''}
                  isInvalid={formik.touched.usersMobile && formik.errors.usersMobile}
                />
                <Form.Control.Feedback type="invalid">
                  {formik.errors.usersMobile}
                </Form.Control.Feedback>
              </div>
            </div>

            <div className="col-xl-4">
              <div className="form-group mb-3">
                <label className="form-label">{t('Start Date')}</label>
                <Form.Control
                  type="date"
                  className="form-control"
                  name="startDate"
                  onChange={formik.handleChange}
                  value={formik.values.startDate || ''}
                  isInvalid={formik.touched.startDate && formik.errors.startDate}
                />
                <Form.Control.Feedback type="invalid">
                  {formik.errors.startDate}
                </Form.Control.Feedback>
              </div>
            </div>

            <div className="col-xl-4">
              <div className="form-group mb-3">
                <label className="form-label">{t('Date_TO')}</label>

                <Form.Control
                  type="date"
                  className="form-control"
                  name="endDate"
                  onChange={formik.handleChange}
                  value={formik.values.endDate || ''}
                  isInvalid={formik.touched.endDate && formik.errors.endDate}
                />
                <Form.Control.Feedback type="invalid">
                  {formik.errors.endDate}
                </Form.Control.Feedback>
              </div>
            </div>

            <div className="col-xl-4">
              <div className="form-group mb-3">
                <label className="form-label">{t('Active')}</label>
                <div className="form-control d-flex align-items-center">
                  <Form.Check
                    // style={{ margin: '10px 20px' }}
                    type="switch"
                    label=""
                    name="isActive"
                    checked={formik.values.isActive}
                    onChange={formik.handleChange}
                    value={formik.values.isActive || ''}
                    isInvalid={formik.touched.isActive && formik.errors.isActive}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="col-xl-12">
            <div className="form-group mb-3">
              <label className="form-label">{t('Note')}</label>
              <Form.Control
                className="form-control"
                as="textarea"
                rows={2}
                name="description"
                onChange={formik.handleChange}
                value={formik.values.description || ''}
              />
              <div></div>
            </div>
          </div>

          <div className="d-flex gap-2">
            <button
              disabled={formik.isSubmitting}
              type="submit"
              className="btn btn-lg btn-theme w-100">
              {formik.isSubmitting ? (
                <div className="spinner-border spinner-border-sm me-2"></div>
              ) : (
                <i className="fa fa-save fa-fw me-1"></i>
              )}
              {t('Save')}
            </button>

            <button
              type="button"
              className=" btn  btn-lg btn-warning w-100"
              onClick={handleResetPassword}>
              <i className="fbi bi-arrow-clockwise me-1"></i>
              {t('ResetPassword')}
            </button>
            <button
              type="button"
              className="btn btn-lg btn-default w-100"
              data-bs-dismiss="modal"
              id="closeModalForm">
              <i className="fa fa-power-off fa-fw me-1"></i> {t('Cancel')}
            </button>
          </div>
        </Form>
      </Loading>
    </>
  );
}

export default EditUser;
